import { Network } from '@amzn/awscat-portfolio-assessment-types';
import { Badge, SpaceBetween } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../common/table/types';
import { getCell } from '../common/awsui-table-helper';
import { MetadataItem } from '../common/AWSUIFormBuilder';

export const excludeFromTCOToDisplayMap: Map<string, string> = new Map([
    ['aws', 'AWS'],
    ['onPremises', 'On-Premises'],
]);

export const networkMetadata: MetadataItem<Network>[] = [
    {
        identifier: 'sizeOfPipeMB',
        type: 'number',
        defaultValue: 1,
        label: 'Size of Pipe (Mbits per second)',
        uiHidden: false,
        uiDisabled: false,
        validation: {
            decimalPlaces: 0,
            min: 1,
            max: 99999
        }
    },
    {
        identifier: 'ratio',
        type: 'number',
        defaultValue: 3,
        label: 'Peak/Average Ratio',
        uiHidden: false,
        uiDisabled: false,
        validation: {
            decimalPlaces: 0,
            min: 0,
            max: 10
        }
    },
    {
        identifier: 'redundantPipe',
        type: 'enum',
        defaultValue: 'true',
        enum: [
            {
                value: 'true',
                text: 'Yes'
            },
            {
                value: 'false',
                text: 'No'
            }
        ],
        label: 'Redundant Pipe',
        uiHidden: false,
        uiDisabled: false,
    },
    {
        identifier: 'internetEgress',
        type: 'number',
        defaultValue: 0,
        label: 'AWS Egress Data Transfer(GB/Month)',
        description: 'Whenever is zero, AWS egress data transfer will be calculated based on on-premises pipe size.',
        uiHidden: false,
        uiDisabled: false,
        validation: {
            decimalPlaces: 2,
            min: 0,
            max: 9999999
        }
    },
    {
        identifier: 'excludeFromTco',
        type: 'multiValueEnum',
        defaultValue: [],
        label: 'Exclude from TCO assessment',
        selections: [
            { value: 'aws', text: 'AWS', uiDisabled: false },
            { value: 'onPremises', text: 'On-Premises', uiDisabled: false },
        ],
        uiHidden: false,
        uiDisabled: false,
    },
];

export const networkColumnDefinition: ColumnDefinition<Network>[] = [
    {
        id: 'sizeOfPipeMB',
        header: constants.NETWORK_SIZE_OF_PIPE,
        cell: item => getCell(item.sizeOfPipeMB),
        type: ColumnTypes.NUMBER,
    },
    {
        id: 'ratio',
        header: constants.NETWORK_RATIO,
        cell: item => getCell(item.ratio),
        type: ColumnTypes.NUMBER,
    },
    {
        id: 'redundantPipe',
        header: constants.NETWORK_REDUNDANT_PIPE,
        cell: item => item.redundantPipe === 'true' ? 'Yes' : 'No',
        type: ColumnTypes.TEXT,
    },
    {
        id: 'internetEgress',
        header: constants.NETWORK_INTERNET_EGRESS,
        cell: item => getCell(item.internetEgress),
        type: ColumnTypes.NUMBER,
    },
    {
        id: 'excludeFromTco',
        header: constants.NETWORK_EXCLUDE_FROM_TCO,
        data: item => item.excludeFromTco.join(','),
        cell: item => item.excludeFromTco ? (
            <SpaceBetween direction='horizontal' size='s'>
                {item.excludeFromTco.map(exclude => (
                    <Badge
                        key={exclude}
                        color='blue'
                    >
                        {excludeFromTCOToDisplayMap.get(exclude)}
                    </Badge>
                ))}
            </SpaceBetween>
        ) : '-',
        type: ColumnTypes.CUSTOM,
    },
];
